import toastr from 'toastr'

import HttpWrapper from '@/utils/http/httpWrapper'

import ShipbobAppSettings from '../../appSettings/appSetting'

export const WMS_API = ShipbobAppSettings.wmsApi
export const RECEIVING_API = ShipbobAppSettings.receivingApi
export const INVENTORY_DISTRIBUTION_API = ShipbobAppSettings.INVENTORY_DISTRIBUTION_API

export const MERCHANT_WRO_DRAFT_CONTROLLER = '/api/warehouseReceivingDraftOrders'
export const MERCHANT_WRO_DRAFT_CONTROLLER_V2 = '/api/v2/warehouseReceivingDraftOrders'
export const BASE_RECEIVING_DRAFT_CONTROLLER = RECEIVING_API + MERCHANT_WRO_DRAFT_CONTROLLER
export const BASE_RECEIVING_DRAFT_CONTROLLER_V2 = RECEIVING_API + MERCHANT_WRO_DRAFT_CONTROLLER_V2

const errorCallback = errorResponse => toastr.error(errorResponse.response.data.message)

class CreateWroServiceInternal {
  urls () {
    return {
      getWroDraftV2: BASE_RECEIVING_DRAFT_CONTROLLER_V2,
      getWroDrafts: BASE_RECEIVING_DRAFT_CONTROLLER,
      submitWro: WMS_API + '/api/warehouse-receiving-orders',
      updateFc: BASE_RECEIVING_DRAFT_CONTROLLER,
      updateProducts: BASE_RECEIVING_DRAFT_CONTROLLER,
      deleteWro: BASE_RECEIVING_DRAFT_CONTROLLER,
      updateShippingType: BASE_RECEIVING_DRAFT_CONTROLLER,
      arrivalDetails: BASE_RECEIVING_DRAFT_CONTROLLER,
      boxLabels: RECEIVING_API + '/api/warehouseReceivingOrders/{wroid}/boxLabelUrl',
      completeWro: BASE_RECEIVING_DRAFT_CONTROLLER + '/{wroid}/complete',
      editWro: RECEIVING_API + '/api/WarehouseReceivingOrders/{wroid}/edit',
      getProductWarnings: RECEIVING_API + MERCHANT_WRO_DRAFT_CONTROLLER + '/getProductWarnings',
      getAvailableWroDestinationsForSourceHub: INVENTORY_DISTRIBUTION_API + '/api/v2/receiving/{hubFcId}/locations'
    }
  }

  async getBoxLabels (wroid) {
    const request = {
      Url: this.urls().boxLabels.replace('{wroid}', wroid),
      ResponseType: 'string'
    }
    return await HttpWrapper.Get(request, null, null, false)
  }

  async submitWro (Data) {
    const request = {
      Url: this.urls().submitWro,
      Data
    }
    return await HttpWrapper.Post(request, null, (errorResponse) => {
      errorResponse.response.data.details && errorResponse.response.data.details.length ? toastr.error(errorResponse.response.data.details[0]) : toastr.error('Invalid draft WRO')
    }, true)
  }

  async createWro (Data) {
    const request = {
      Url: BASE_RECEIVING_DRAFT_CONTROLLER,
      Data
    }
    return await HttpWrapper.Post(request, null, errorCallback, true)
  }

  async completeWro (wroid) {
    return await HttpWrapper.Put({ Url: this.urls().completeWro.replace('{wroid}', wroid) }, null, null, true)
  }

  async getWroDraftV2 (id) {
    const request = {
      Url: `${this.urls().getWroDraftV2}/${id}`
    }
    return await HttpWrapper.Get(request)
  }

  async getWroToBeEdited (wroid) {
    const request = {
      Url: this.urls().editWro.replace('{wroid}', wroid)
    }
    return await HttpWrapper.Get(request)
  }

  async getWroDrafts () {
    const request = { Url: this.urls().getWroDrafts }
    return await HttpWrapper.Get(request)
  }

  async updateFc ({ data, id }) {
    const request = {
      Url: `${BASE_RECEIVING_DRAFT_CONTROLLER}/${id}/fulfillmentCenter`,
      Data: data
    }
    return await HttpWrapper.Put(request, null, errorCallback, true)
  }

  async updateProducts ({ data, id }) {
    const request = {
      Url: `${BASE_RECEIVING_DRAFT_CONTROLLER}/${id}/products`,
      Data: data
    }
    return await HttpWrapper.Put(request, null, (errorCallback) => {
      toastr.error('Invalid products added.')
    }, true)
  }

  async updateShippingType ({ data, id }) {
    const request = {
      Url: `${BASE_RECEIVING_DRAFT_CONTROLLER}/${id}/shippingType`,
      Data: data
    }
    return await HttpWrapper.Put(request, null, errorCallback, true)
  }

  async updateShippingConfigurations ({ data, id }) {
    const request = {
      Url: `${BASE_RECEIVING_DRAFT_CONTROLLER}/${id}/shippingConfigurations`,
      Data: data
    }
    return await HttpWrapper.Put(request, null, errorCallback, true)
  }

  async updateMultiSkuShippingConfigurations ({ data, id }) {
    const request = {
      Url: `${BASE_RECEIVING_DRAFT_CONTROLLER}/${id}/multi-sku-shipping-configurations`,
      Data: data
    }
    return await HttpWrapper.Put(request, null, errorCallback, true)
  }

  async deleteWroDraft (id) {
    const request = {
      Url: `${BASE_RECEIVING_DRAFT_CONTROLLER}/${id}`
    }
    return await HttpWrapper.Delete(request)
  }

  async arrivalDetails ({ data, id }) {
    const request = {
      Url: `${this.urls().arrivalDetails}/${id}/arrivalDetails`,
      Data: data,
      Headers: { 'Content-Type': 'multipart/form-data' }
    }
    return await HttpWrapper.Put(request, null, errorCallback, true)
  }

  async fetchBolFile (Url) {
    const request = {
      Url,
      ResponseType: 'arraybuffer'
    }
    return await HttpWrapper.Get(request)
  }

  async getProductWarnings (products) {
    const request = {
      Url: this.urls().getProductWarnings,
      Data: products,
      Headers: { 'Content-Type': 'application/json' }
    }

    return await HttpWrapper.Post(request, false, (response) => { throw response }, true)
  }
}

export const CreateWarehouseReceivingOrderService = new CreateWroServiceInternal()
